import { SisteTilsynState } from "./types";

const initialState: SisteTilsynState = {
      sisteTilsynLoading: [],
      sisteTilsynOk: [],
      sisteTilsynFail: [],
      sisteTilsyn: []
  };

  export default initialState;